import React, { useState, useEffect } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import RandomContent from '../Components/RandomContent';
import Inputs from '../Common/Inputs';
import Output from '../Common/Output';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const decodeJwt = (token) => {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) throw new Error('Invalid JWT Token');

    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );

    return { convertedData: JSON.stringify(JSON.parse(jsonPayload), null, 2), isError: false };
  } catch (error) {
    return { convertedData: 'Invalid JWT token. Please check your input.', isError: true };
  }
};

const JwtDecoder = () => {
  const [inputData, setInputData] = useState('');
  const [outputData, setOutputData] = useState('');
  const [isError, setIsError] = useState(false);
  const [fontSize, setFontSize] = useState(14);
  const [inputLnCol, setInputLnCol] = useState({ line: 1, column: 1 });
  const [outputLnCol, setOutputLnCol] = useState({ line: 1, column: 1 });

  useEffect(() => {
    setInputData('');
    setOutputData('');
    setIsError(false);
  }, []);

  const handleConversion = () => {
    const { convertedData, isError } = decodeJwt(inputData);
    setOutputData(convertedData);
    setIsError(isError);
  };

  return (
    <>
      <div>
        <Header />

        <RandomContent />

        <div className="blog-area pb-20">
          <div className="container-block-fluid">
            <div className="row justify-content-center">
              <div className="full-col col-lg-12 col-md-12">
                <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="2800">
                  <div className="details">
                    <h4><a href="#">Decode JWT Token</a></h4>
                    <p>
                      Use our Free JWT Decoder Tool to decode and view the contents of a JSON Web Token. This tool extracts and formats the JWT payload so you can easily inspect claims and other data. Safe, fast, and offline—perfect for developers and security testers.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="blog-area pb-20">
          <div className="container-block-fluid">
            <div className="row justify-content-center">

              {/* Input */}
              <div className="full-col col-lg-5 col-md-5">
                <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="2800">
                  <div className="thumb">
                    <Inputs
                      value={inputData}
                      setValue={(val) => {
                        setInputData(val);
                        setIsError(false);
                      }}
                      fontSize={fontSize}
                      setFontSize={setFontSize}
                      isError={false}
                      lineCol={inputLnCol}
                      setLineCol={setInputLnCol}
                      readOnly={false}
                      idPrefix="input"
                      placeholder="Enter JWT token here"
                    />
                  </div>
                </div>
              </div>

              {/* Decode Button */}
              <div
                className="w3-col m2"
                style={{
                  flex: 2,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <button
                  className="default-btn icon four"
                  onClick={handleConversion}
                  disabled={!inputData.trim()}
                >
                  <i className="ri-exchange-line"></i>
                  Decode
                </button>
              </div>

              {/* Output */}
              <div className="full-col col-lg-5 col-md-5">
                <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="1200">
                  <div className="thumb">
                    <Output
                      value={outputData}
                      lineCol={outputLnCol}
                      setLineCol={setOutputLnCol}
                      fontSize={fontSize}
                      setFontSize={setFontSize}
                      isError={isError}
                      readOnly={true}
                      idPrefix="output"
                    />
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <Footer />
      <ToastContainer />
    </>
  );
};

export default JwtDecoder;
